import { SimpleCheckbox } from '@dreamstack/simple-components/src/lib/SimpleCheckbox'
import type { FunctionComponent } from 'react'
import { useIsReservationUi } from '../../../next/useIsReservationUi'

export const TableSwitch: FunctionComponent<
  React.PropsWithChildren<{
    showTableView: boolean
    setShowTableView: (current: boolean) => void
  }>
> = ({ showTableView, setShowTableView }) => {
  const isReservationUi = useIsReservationUi()
  if (!isReservationUi) return null
  return (
    <div className="col-span-full flex flex-row justify-end">
      {/* TODO: style */}
      <SimpleCheckbox
        formControlProps={{ label: 'Tabellenansicht' }}
        checkBoxProps={{
          value: showTableView,
          onChange: (_, checked) => {
            setShowTableView(checked)
          },
        }}
      />
    </div>
  )
}
